<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Микросервисы</h2>
          <div class="px-3"></div>
          <v-select
            :items="metrics"
            v-model="metric"
            label="Метрика" dense hide-details style="max-width: 300px" class="mx-3"
          ></v-select>
          <v-select
            :items="countVariants"
            v-model="count"
            item-value="value"
            item-text="text"
            label="за время" dense hide-details style="max-width: 300px" class="mx-3"
          ></v-select>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-card tile flat>
          <v-card-text>
            <LineChart :height="260" :chartData="chartData" :options="options"></LineChart>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-data-table no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
          :headers="headers"
          :items="microservices"
          :items-per-page="-1"
          item-key="name" :sort-by="null"
          hide-default-footer
          dense text
        >
          <template v-slot:item.started="{ item }">
            <div :class="howOldStyle(item.started)">{{ dateFormat(item.started) }}</div>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LineChart from '@/components/LineChart'
import moment from 'moment'
import ColorHash from 'color-hash'
const colorHash = new ColorHash({ saturation: [0.25, 0.85] }, { lightness: [0.25, 0.9] })
let to = null
export default {
  name: 'Microservices',
  components: { LineChart },
  data: () => ({
    ms: [],
    metrics: [
      'trafficPm', 'memUsedMb', 'averageLatancyMs', 'maxLatencyMs'
    ],
    metric: 'trafficPm',
    microservicesSequence: [],
    microservices: [],
    options: {
      responsive: true,
      maintainAspectRatio: false
    },
    headers: [
      { text: 'name', value: 'name'},
      { text: 'version', value: 'version'},
      { text: 'started', value: 'started'},
      { text: 'trafficPm', value: 'trafficPm'},
      { text: 'memUsedMb', value: 'memUsedMb'},
      { text: 'averageLatancyMs', value: 'averageLatancyMs'},
      { text: 'maxLatencyMs', value: 'maxLatencyMs'},
    ],
    count: 60,
    countVariants: [
      { text: '1 час', value: 60 },
      { text: '3 часа', value: 180 },
      { text: '6 часов', value: 360 },
      { text: '12 часов', value: 720 },
      { text: '24 часа', value: 1440 },
    ]
  }),
  methods: {
    async fetch () {
      try {
        await Promise.all([
          this.fetchMicroservices(),
          this.fetchMicroservicesSequence()
        ])
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        if (to) clearTimeout(to)
        to = setTimeout(this.fetch, 60000)
      }
    },
    async fetchMicroservices () {
      const { microservices } = await this.$store.dispatch('sioRequest', {
        topic: 'microservices'
      })
      this.microservices = microservices
    },
    async fetchMicroservicesSequence () {
      const { microservicesSequence } = await this.$store.dispatch('sioRequest', {
        topic: 'microservices-sequence',
        pl: { count: this.count }
      })
      this.microservicesSequence = microservicesSequence
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    howOldStyle (date) {
      const diff = moment.duration(moment().diff(moment(date, 'YYYY-MM-DD HH:mm:ssZ'))).asHours()
      if (diff < 1) return 'ms-new-one'
      if (diff < 24) return 'ms-not-new-not-old'
      return 'ms-old-one'
    },
  },
  computed: {
    chartData () {
      if (!this.microservicesSequence.length) return null
      const labels = Array.from(Array(this.microservicesSequence.length).keys()).reverse().map(x => '-' + x)
      let data = this.microservicesSequence.reduce((r, t) => {
        t.forEach(x => {
          if (!r[x.name]) r[x.name] = []
          r[x.name].push(x[this.metric])
        })
        return r
      }, {})
      const datasets = Object.keys(data).map(k => ({
        data: data[k],
        label: k,
        borderColor: colorHash.hex(k.slice(0, -6)),
        backgroundColor: 'transparent',
        pointRadius: 1
      }))
      return {
        labels,
        datasets
      }
    },
    profile () {
      return this.$store.state.profile
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    count () {
      if (this.profile) this.fetch()
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  },
  destroyed () {
    if (to) clearTimeout(to)
  }
}
</script>

<style lang="css">
.ms-new-one {
  background-color: rgba(50, 250, 70, 0.2)
}
.ms-not-new-not-old {
  background-color: rgba(50, 250, 70, 0.04)
}
.ms-old-one {
  background-color: rgba(30, 70, 200, 0.1)
}
</style>
